export default __webpack_public_path__ + "static/media/img-1.22f1afd0.jpg";